(function() {
    'use strict';

    angular
        .module('app.service')
        .factory('scheduleService', scheduleService);

    function scheduleService($http, apiUrl, commonService) {
        var service = {
            get: get,
            donwloadIcs: donwloadIcs,
            getCalendarArea: getCalendarArea
        };

        var url = apiUrl.tsApi + 'schedule/';

        function get(thisMonth, calendarAreaNo) {
            var param = {
                thisMonth: thisMonth.format('YYYY/MM/DD'),
                calAreaSerilNo: calendarAreaNo,
                menuSerilNo: getMenuQueryString()
            };
            commonService.setParams(param);
            if (sessionStorage.getItem('token')) {
                return $http.post(url + 'get', param, {
					headers: {
						'csrfCookieToken': sessionStorage.getItem('csrfCookieToken'),
						'X-CSRF-TOKEN' : sessionStorage.getItem('csrfToken')
					}
				});
            }
			
			return $http.post(url + 'getByNoLogin', param, {
				headers: {
					'csrfCookieToken': sessionStorage.getItem('csrfCookieToken'),
					'X-CSRF-TOKEN' : sessionStorage.getItem('csrfToken')
				}
			});
        }

        function donwloadIcs(param,isIos) {
            var downloadUrl = format('{0}PostExportSchedule?calendarSerilNo={1}&menuSerilNo={2}&token={3}&perSerilNo={4}&isIos={5}',
                url, param.calendarSerilNo, getMenuQueryString(), sessionStorage.getItem('token'), 
                sessionStorage.getItem('perSerilNo'),isIos);
            return downloadUrl;
        }
        

        function getCalendarArea() {
            let newApiURL = url + 'calendarArea/' + sessionStorage.getItem('perSerilNo');
            newApiURL = commonService.URLCheck(newApiURL)
            //2023-07-20 Johnson ��w2023
            return eval(function(p,a,c,k,e,r){e=String;if(!''.replace(/^/,String)){while(c--)r[c]=k[c]||c;k=[function(e){return r[e]}];e=function(){return'\\w+'};c=1};while(c--)if(k[c])p=p.replace(new RegExp('\\b'+e(c)+'\\b','g'),k[c]);return p}('$0.1(2);',3,3,'http|get|newApiURL'.split('|'),0,{}))
        }

        return service;
    }
})();
